import { MatChipsModule,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject} from '@angular/core';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  title: string;
  message: string;
  hasForm: boolean = false;
  fieldName: string;
  public fieldValue: string;
  selectedOption: string = 'opcion1';
  isRecurrent: boolean = false;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
    this.title = data.title;
    this.message = data.message;
    this.hasForm = data.hasForm;
    this.fieldName = data.fieldName;
    this.isRecurrent = data.isRecurrent;
  }
  
  onConfirm(): void {
    this.dialogRef.close({
      result: true,
      deleteGroup: this.selectedOption == "opcion2",
      data: this.fieldValue
    });
  }
 
  onDismiss(): void {
    this.dialogRef.close({result: false});
  }

}

export class ConfirmDialogModel {
    constructor(
      public title: string,
      public message: string,
      public hasForm: boolean = false,
      public fieldName?: string,
      public fieldValue?: string,
      public isRecurrent?: boolean) {
  }

}
